import { useMutationEndpoint, UseMutationOptionsFromProvider } from '../../core'
import { postAuthMfaSetupVerify } from '../endpoints'

type MutationParams = Parameters<typeof postAuthMfaSetupVerify>[0]

export const useAuthMfaSetupVerifyPostMutation = (
  options?: UseMutationOptionsFromProvider<
    typeof postAuthMfaSetupVerify,
    MutationParams
  >,
) =>
  useMutationEndpoint(
    (data: MutationParams) => postAuthMfaSetupVerify(data),
    options,
  )
